function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { defineComponent, reactive, ref, onMounted, watch, getCurrentInstance } from "vue";
import { definePropType } from "@types-vue/props";
export default defineComponent({
    props: {
        config: {
            type: definePropType(Object),
            default: function() {
                return {};
            }
        },
        formValue: {
            type: Object,
            default: function() {
                return {};
            }
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var query = reactive({});
        var orderSelect = ref("");
        var order = ref("descending");
        watch(function() {
            return props.formValue;
        }, function() {
            if (props.formValue[props.config.prop].indexOf("-") !== -1) {
                orderSelect.value = props.formValue[props.config.prop].substring(1);
                order.value = "descending";
            } else {
                orderSelect.value = props.formValue[props.config.prop];
                order.value = "ascending";
            }
        }, {
            immediate: true,
            deep: true
        });
        var handleChange = function() {
            var activeOrder = "";
            if (order.value === "descending") {
                activeOrder = "-" + orderSelect.value;
            } else {
                activeOrder = orderSelect.value;
            }
            // eslint-disable-next-line vue/no-mutating-props
            props.formValue[props.config.prop] = activeOrder;
            if (props.config.handleChange) {
                props.config.handleChange(activeOrder);
            } else {
                root.$router.push({
                    query: props.formValue
                });
            }
            emit("handleChange", activeOrder);
        // props.config.handleChange && props.config.handleChange(activeOrder)
        };
        var changeOrder = function() {
            if (order.value === "descending") {
                order.value = "ascending";
            } else {
                order.value = "descending";
            }
            handleChange();
        };
        onMounted(function() {
            Object.assign(query, _objectSpread({}, props.formValue));
        });
        return {
            orderSelect: orderSelect,
            order: order,
            handleChange: handleChange,
            changeOrder: changeOrder
        };
    }
});
